import { NumberInputProps } from '@mantine/core';
import { Group } from 'src/design/atoms/Group';
import { NumberInput } from 'src/design/atoms/NumberInput';
import React from 'react';

type HoursInputProps = NumberInputProps;

export const HoursInput: React.FC<HoursInputProps> = ({ ...props }) => {
  return (
    <Group justify="center">
      <NumberInput
        {...props}
        size="xs"
        px="auto"
        w="80"
        decimalScale={2}
        min={0}
        max={24}
      />
    </Group>
  );
};
